import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { LoaderComponent } from '../../shared/components/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private overlay = inject(Overlay);
  requestCounter = 0;
  overlayRef: OverlayRef | null = null;
  loaderPortal = new ComponentPortal(LoaderComponent);

  openOverlay(skip?: boolean): void {
    if (!skip) this.requestCounter += 1;
    if (!this.overlayRef) {
      this.overlayRef = this.createOverlay();
      this.overlayRef.attach(this.loaderPortal);
    }
  }

  closeOverlay(): void {
    if (this.requestCounter > 0) this.requestCounter -= 1;
    if (this.requestCounter === 0 && this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  forceCloseOverlay(): void {
    this.requestCounter = 0;
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  private createOverlay(): OverlayRef {
    const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
    const overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      positionStrategy: positionStrategy
    });
    return this.overlay.create(overlayConfig);
  }
}
